import { FC } from "react";
import { useRouteError, isRouteErrorResponse, Link } from "react-router-dom";
import { Container, Title, Text, Button, Stack, Code } from "@mantine/core";

export const RouteErrorPage: FC = () => {
  const error = useRouteError();

  let title = "Etwas ist schiefgelaufen";
  let message = "Ein unerwarteter Fehler ist aufgetreten.";

  if (isRouteErrorResponse(error)) {
    if (error.status === 404) {
      title = "Seite nicht gefunden";
      message = "Die angeforderte Seite existiert nicht.";
    } else if (error.status === 500) {
      title = "Serverfehler";
      message = "Es gab ein Problem mit dem Server.";
    } else {
      title = `Fehler ${error.status}`;
      message = error.statusText || message;
    }
  }

  const errorMessage =
    error instanceof Error ? error.message : "Unbekannter Fehler";
  const errorStack = error instanceof Error ? error.stack : undefined;

  return (
    <Container size="sm" py="xl">
      <Stack align="center" gap="md">
        <Title order={2}>{title}</Title>
        <Text c="dimmed" ta="center">
          {message}
        </Text>

        <Code block w="100%">
          {errorMessage}
          {errorStack && (
            <>
              {"\n\n"}
              {errorStack}
            </>
          )}
        </Code>

        <Button component={Link} to="/">
          Zur Startseite
        </Button>
      </Stack>
    </Container>
  );
};
